import axios from 'axios'

const BASE_URL = process.env.REACT_APP_NEXTERA_API

export const holesTypeCodes = [
  'FALL_ROTECTION_OPENING_PROTECTED',
  'FALL_ROTECTION_FLR_COVRS',
]

export type SafetyMetricSlug =
  | 'ppe_compliance'
  | 'guardrails'
  | 'lighting'
  | 'fire_extinguishers'
  | 'holes'
  | 'clutter'
  | 'wet_surface'
  | 'snow_ice'
  | 'floor_protection'
  | 'heat_index'
  | 'fumes'
  | 'air_quality'
export type SafetyMetricDetailDisplayMode = 'gallery' | 'floor_plan'

export interface SafetyMetricMetadataEntry {
  display_mode: SafetyMetricDetailDisplayMode
  category?: string
  color: string
  order: number
  metric_tile_name: string
  view_mode_menu_name: string
  type_codes?: string[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper metric type
  calulate_metric_summary_value: (metric: any) => number
  dateSelectorTitle?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
  getProjectSummary: (overallSummary: any, projectId: string) => any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
  getDateSummary: (overallSummary: any, projectId: string) => any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
  getFilteredDateSummary: (overallSummary: any, projectId: string) => any
}

export type SafetyMetricMetaData = Record<
  SafetyMetricSlug,
  SafetyMetricMetadataEntry
>

const divide = (numerator: number, denominator: number) => {
  return denominator === 0 ? 1 : numerator / denominator
}

export const safetyMetricMetaData: SafetyMetricMetaData = {
  ppe_compliance: {
    display_mode: 'gallery',
    category: 'PPE',
    color: '#4339F2',
    order: 1,
    metric_tile_name: 'PPE Compliance',
    view_mode_menu_name: 'PPE',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper metric type
    calulate_metric_summary_value: (metric: any) => {
      return divide(metric.fully_compliant, metric._total)
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getProjectSummary: (overallSummary: any, projectId: string) =>
      overallSummary ? overallSummary.floor_summary[projectId]?._all : null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary && overallSummary.date_summary
        ? overallSummary.date_summary[projectId]
        : null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getFilteredDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary && overallSummary.filtered_date_summary
        ? overallSummary.filtered_date_summary[projectId]
        : null,
  },
  guardrails: {
    display_mode: 'floor_plan',
    metric_tile_name: 'Guardrails',
    view_mode_menu_name: 'Guardrails',
    color: '#14B8A6',
    order: 2,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper metric type
    calulate_metric_summary_value: (metric: any) => {
      return divide(metric.items - metric.unsafe, metric.items)
    },
    dateSelectorTitle: 'Guardrails As Of',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getProjectSummary: (overallSummary: any, projectId: string) =>
      overallSummary ? overallSummary.floor_summary[projectId]?._all : null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary && overallSummary.date_summary
        ? overallSummary.date_summary[projectId]
        : null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getFilteredDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary && overallSummary.filtered_date_summary
        ? overallSummary.filtered_date_summary[projectId]
        : null,
  },
  lighting: {
    metric_tile_name: 'Lighting',
    view_mode_menu_name: 'Lighting',
    display_mode: 'floor_plan',
    color: '#22D3EE',
    order: 3,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper metric type
    calulate_metric_summary_value: (metric: any) => {
      return divide(metric.compliant, metric._total)
    },
    dateSelectorTitle: 'Lighting As Of',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getProjectSummary: (overallSummary: any, projectId: string) =>
      overallSummary ? overallSummary.floor_summary[projectId]?._all : null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary && overallSummary.date_summary
        ? overallSummary.date_summary[projectId]
        : null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getFilteredDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary && overallSummary.filtered_date_summary
        ? overallSummary.filtered_date_summary[projectId]
        : null,
  },
  fire_extinguishers: {
    metric_tile_name: 'Fire Extinguishers',
    view_mode_menu_name: 'Fire',
    display_mode: 'floor_plan',
    color: '#8B5CF6',
    order: 4,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper metric type
    calulate_metric_summary_value: (metric: any) => {
      return divide(metric.compliant, metric._total)
    },
    dateSelectorTitle: 'Fire Extinguishers As Of',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getProjectSummary: (overallSummary: any, projectId: string) =>
      overallSummary ? overallSummary.floor_summary[projectId]?._all : null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary && overallSummary.date_summary
        ? overallSummary.date_summary[projectId]
        : null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getFilteredDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary && overallSummary.filtered_date_summary
        ? overallSummary.filtered_date_summary[projectId]
        : null,
  },
  holes: {
    metric_tile_name: 'Holes',
    view_mode_menu_name: 'Holes',
    display_mode: 'gallery',
    type_codes: holesTypeCodes,
    color: '#FB7185',
    order: 5,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper metric type
    calulate_metric_summary_value: (metric: any) => {
      return divide(metric.safe, metric.total)
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getProjectSummary: (overallSummary: any, _projectId: string) =>
      overallSummary,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getDateSummary: (overallSummary: any, _projectId: string) =>
      overallSummary?.date_summary,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getFilteredDateSummary: (overallSummary: any, _projectId: string) =>
      overallSummary?.filtered_date_summary,
  },
  clutter: {
    metric_tile_name: 'Clutter',
    view_mode_menu_name: 'Clutter',
    display_mode: 'floor_plan',
    color: '#10B981',
    order: 6,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper metric type
    calulate_metric_summary_value: (metric: any) => {
      return divide(metric.signal, metric.total_units)
    },
    dateSelectorTitle: 'Clutter As Of',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getProjectSummary: (overallSummary: any, projectId: string) =>
      overallSummary ? overallSummary.floor_summary[projectId]?._all : null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary && overallSummary.date_summary
        ? overallSummary.date_summary[projectId]
        : null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getFilteredDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary && overallSummary.filtered_date_summary
        ? overallSummary.filtered_date_summary[projectId]
        : null,
  },
  wet_surface: {
    metric_tile_name: 'Wet Surface',
    view_mode_menu_name: 'Wet Surface',
    display_mode: 'floor_plan',
    color: '#10B981',
    order: 7,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper metric type
    calulate_metric_summary_value: (metric: any) => {
      return divide(metric.inverse_signal, metric.total_units)
    },
    dateSelectorTitle: 'Wet Surfaces As Of',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getProjectSummary: (overallSummary: any, projectId: string) =>
      overallSummary ? overallSummary.floor_summary[projectId]?._all : null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary && overallSummary.date_summary
        ? overallSummary.date_summary[projectId]
        : null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getFilteredDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary && overallSummary.filtered_date_summary
        ? overallSummary.filtered_date_summary[projectId]
        : null,
  },
  snow_ice: {
    metric_tile_name: 'Snow and Ice',
    view_mode_menu_name: 'Snow and Ice',
    display_mode: 'floor_plan',
    color: '#10B981',
    order: 8,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper metric type
    calulate_metric_summary_value: (metric: any) => {
      return divide(metric.inverse_signal, metric.total_units)
    },
    dateSelectorTitle: 'Snow and Ice As Of',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getProjectSummary: (overallSummary: any, projectId: string) =>
      overallSummary ? overallSummary.floor_summary[projectId]?._all : null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary && overallSummary.date_summary
        ? overallSummary.date_summary[projectId]
        : null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getFilteredDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary && overallSummary.filtered_date_summary
        ? overallSummary.filtered_date_summary[projectId]
        : null,
  },
  floor_protection: {
    metric_tile_name: 'Floor Protection',
    view_mode_menu_name: 'Floor Protection',
    display_mode: 'floor_plan',
    color: '#ABC0D9',
    order: 9,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper metric type
    calulate_metric_summary_value: (metric: any) => {
      return divide(metric.inverse_signal, metric.total_units)
    },
    dateSelectorTitle: 'Floor Protection As Of',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getProjectSummary: (overallSummary: any, projectId: string) =>
      overallSummary ? overallSummary.floor_summary[projectId]?._all : null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary && overallSummary.date_summary
        ? overallSummary.date_summary[projectId]
        : null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getFilteredDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary && overallSummary.filtered_date_summary
        ? overallSummary.filtered_date_summary[projectId]
        : null,
  },
  heat_index: {
    metric_tile_name: 'Heat Index',
    view_mode_menu_name: 'Heat Index',
    display_mode: 'floor_plan',
    color: '#F59E0B',
    order: 10,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper metric type
    calulate_metric_summary_value: (metric: any) => metric?.value ?? 0,
    dateSelectorTitle: 'Heat Index As Of',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getProjectSummary: (overallSummary: any, projectId: string) =>
      overallSummary ? overallSummary.floor_summary?.[projectId]?._all : null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary?.date_summary?.[projectId] ?? null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getFilteredDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary?.filtered_date_summary?.[projectId] ?? null,
  },
  fumes: {
    metric_tile_name: 'Fumes',
    view_mode_menu_name: 'Fumes',
    display_mode: 'floor_plan',
    color: '#EC4899',
    order: 11,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper metric type
    calulate_metric_summary_value: (metric: any) => metric?.value ?? 0,
    dateSelectorTitle: 'Fumes As Of',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getProjectSummary: (overallSummary: any, projectId: string) =>
      overallSummary ? overallSummary.floor_summary?.[projectId]?._all : null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary?.date_summary?.[projectId] ?? null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getFilteredDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary?.filtered_date_summary?.[projectId] ?? null,
  },
  air_quality: {
    metric_tile_name: 'Air Quality',
    view_mode_menu_name: 'Air Quality',
    display_mode: 'floor_plan',
    color: '#22C55E',
    order: 12,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper metric type
    calulate_metric_summary_value: (metric: any) => metric?.value ?? 0,
    dateSelectorTitle: 'Air Quality As Of',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getProjectSummary: (overallSummary: any, projectId: string) =>
      overallSummary ? overallSummary.floor_summary?.[projectId]?._all : null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary?.date_summary?.[projectId] ?? null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper overallSummary and return types
    getFilteredDateSummary: (overallSummary: any, projectId: string) =>
      overallSummary?.filtered_date_summary?.[projectId] ?? null,
  },
}

type LightingMetricParamNames =
  | 'project_id'
  | 'floor_code'
  | 'taken_on__gte'
  | 'taken_on__lte'
type LightingMetricParams = Partial<Record<LightingMetricParamNames, string>>

export interface LightingMetric {
  id: number
  viewpoints_image_id: number
  foot_candles: string
  taken_on: string
  viewpoint: number
}

interface LightingCounts {
  foot_candles: number
  compliant: number
  _total: number
}

export type LightingMetricFloorSummary = { _all: LightingCounts } & Partial<
  Record<string, { _all: LightingCounts } & Record<string, LightingCounts>>
>
export type LightingMetricDateSummary = Partial<
  Record<string, Record<string, LightingCounts>>
>
export interface LightingMetricSummary {
  floor_summary: LightingMetricFloorSummary
  date_summary: LightingMetricDateSummary
}

export const fetchLightingMetrics = async (
  params?: LightingMetricParams,
): Promise<LightingMetric[]> => {
  const res = await axios.get(`${BASE_URL}/safety/lighting-metrics`, {
    params: params,
  })
  const response = await res.data
  return response.data
}

export const fetchLightingMetricSummary = async (
  params?: LightingMetricParams,
): Promise<LightingMetricSummary> => {
  const res = await axios.get(`${BASE_URL}/safety/lighting-metrics/summary`, {
    params: params,
  })
  const response = await res.data
  return response.data
}

type PPEMetricParamNames =
  | 'project_id'
  | 'floor_code'
  | 'taken_on__gte'
  | 'taken_on__lte'
type PPEMetricParams = Partial<Record<PPEMetricParamNames, string>>

export interface PPEMetric {
  id: number
  viewpoints_image_id: number
  hard_hat_compliant: boolean
  high_visibility_vest_compliant: boolean
  gloves_compliant: boolean
  glasses_compliant: boolean
  fully_compliant: boolean
}

export type PPEMetricFloorSummary = { _all: ComplianceCounts } & Partial<
  Record<string, { _all: ComplianceCounts } & Record<string, ComplianceCounts>>
>
export type PPEMetricDateSummary = Partial<
  Record<string, Record<string, ComplianceCounts>>
>
export interface PPEMetricSummary {
  floor_summary: PPEMetricFloorSummary
  date_summary: PPEMetricDateSummary
}

interface ComplianceCounts {
  fully_compliant: number
  _total: number
}

export const fetchPPEMetrics = async (
  params?: PPEMetricParams,
): Promise<PPEMetric[]> => {
  const res = await axios.get(`${BASE_URL}/safety/ppe-metrics`, {
    params: params,
  })
  const response = await res.data
  return response.data
}

export const fetchPPEMetricSummary = async (
  params?: PPEMetricParams,
): Promise<PPEMetricSummary> => {
  const res = await axios.get(`${BASE_URL}/safety/ppe-metrics/summary`, {
    params: params,
  })
  const response = await res.data
  return response.data
}

type FireExtinguisherParamNames =
  | 'project_id'
  | 'floor_code'
  | 'taken_on__gte'
  | 'taken_on__lte'
type FireExtinguisherParams = Partial<
  Record<FireExtinguisherParamNames, string>
>

export interface FireExtinguisherViewpointsDistanceMetric {
  id: number
  viewpoints_image_id: number
  distance: number
  compliant: boolean
  taken_on: string
  viewpoint_id: number
}

export const fetchFireExtinguisherViewpointDistanceMetrics = async (
  params?: FireExtinguisherParams,
): Promise<FireExtinguisherViewpointsDistanceMetric[]> => {
  const res = await axios.get(
    `${BASE_URL}/safety/fire-extinguishers/viewpoint-distance-metrics`,
    {
      params: params,
    },
  )
  const response = await res.data
  return response.data
}

interface FireExtinguisherViewpointDistanceCounts {
  distance: number
  compliant: number
  _total: number
}

export type FireExtinguisherViewpointDistanceFloorSummary = {
  _all: FireExtinguisherViewpointDistanceCounts
} & Partial<
  Record<
    string,
    { _all: FireExtinguisherViewpointDistanceCounts } & Record<
      string,
      FireExtinguisherViewpointDistanceCounts
    >
  >
>
export type FireExtinguisherViewpointDistanceDateSummary = Partial<
  Record<string, Record<string, FireExtinguisherViewpointDistanceCounts>>
>
export interface FireExtinguisherViewpointDistanceSummary {
  floor_summary: FireExtinguisherViewpointDistanceFloorSummary
  date_summary: FireExtinguisherViewpointDistanceDateSummary
}

export const fetchFireExtinguisherViewpointDistanceSummary = async (
  params?: FireExtinguisherParams,
): Promise<FireExtinguisherViewpointDistanceSummary> => {
  const res = await axios.get(
    `${BASE_URL}/safety/fire-extinguishers/viewpoint-distance-metrics/summary`,
    {
      params: params,
    },
  )
  const response = await res.data
  return response.data
}

type GuardrailObservationParamNames =
  | 'project_id'
  | 'floor_code'
  | 'taken_on__gte'
  | 'taken_on__lte'
type GuardrailObservationParams = Partial<
  Record<GuardrailObservationParamNames, string>
>
export type GuardrailDesignation = 'safe' | 'unsafe'

export interface GuardrailObservation {
  id: number
  viewpoints_image_id: number
  item_id: number
  observed_quantity: number
  viewpoint: number
  coordinates: string
  observation_id: number
  label_type_id: number
  registered_on: string
  designation: GuardrailDesignation
}

export const fetchGuardrailObservations = async (
  params?: GuardrailObservationParams,
): Promise<GuardrailObservation[]> => {
  const res = await axios.get(`${BASE_URL}/safety/guardrails/observations`, {
    params: params,
  })
  const response = await res.data
  return response.data
}

interface GuardrailObservationCounts {
  safe: number
  unsafe: number
  _total: number
}

interface GuardrailObservationCountsWithItems
  extends GuardrailObservationCounts {
  items: number
}

export type GuardrailObservationFloorSummary = {
  _all: GuardrailObservationCounts
} & Partial<
  Record<
    string,
    { _all: GuardrailObservationCountsWithItems } & Record<
      string,
      GuardrailObservationCountsWithItems
    >
  >
>
export type GuardrailObservationDateSummary = Partial<
  Record<string, Record<string, GuardrailObservationCountsWithItems>>
>
export interface GuardrailObservationSummary {
  floor_summary: GuardrailObservationFloorSummary
  date_summary: GuardrailObservationDateSummary
}

export const fetchGuardrailObservationSummary = async (
  params?: GuardrailObservationParams,
): Promise<GuardrailObservationSummary> => {
  const res = await axios.get(
    `${BASE_URL}/safety/guardrails/observations/summary`,
    {
      params: params,
    },
  )
  const response = await res.data
  return response.data
}

export interface ClutterMetric {
  id: number
  viewpoints_image_id: number
  cluttered: boolean
  taken_on: string
  viewpoint: number
}

interface ProjectTrackerMetricCounts {
  signal: number
  inverse_signal: number
  total_units: number
  _total: number
}

export type ProjectTrackerMetricFloorSummary = {
  _all: ProjectTrackerMetricCounts
} & Partial<
  Record<
    string,
    { _all: ProjectTrackerMetricCounts } & Record<
      string,
      ProjectTrackerMetricCounts
    >
  >
>
export type ProjectTrackerMetricDateSummary = Partial<
  Record<string, Record<string, ProjectTrackerMetricCounts>>
>
export interface ProjectTrackerMetricSummary {
  floor_summary: ProjectTrackerMetricFloorSummary
  date_summary: ProjectTrackerMetricDateSummary
}

export const fetchProjectTrackerMetricSummary = async (
  projectId: string,
  trackerName: string,
): Promise<ProjectTrackerMetricSummary> => {
  // trackerName may contain slashes, so we need to encode it
  const trackerNameEncoded = encodeURIComponent(trackerName)
  const res = await axios.get(
    `${BASE_URL}/project/${projectId}/tracker/${trackerNameEncoded}/summary`,
  )
  const response = await res.data
  return response.data
}

// --- Sensor metrics (heat_index, fumes, air_quality) ---
// Summary shape used by tiles and trend graph. Backend may add /safety/heat-index-metrics/summary etc.
export interface SensorMetricSummaryValue {
  value: number
}

export interface SensorMetricSummary {
  floor_summary: Record<string, { _all: SensorMetricSummaryValue }>
  date_summary: Record<string, Record<string, SensorMetricSummaryValue>>
  filtered_date_summary: Record<
    string,
    Record<string, SensorMetricSummaryValue>
  >
}

type SensorMetricSummaryParams = { project_id?: string; floor_code?: string }

/** Heat index summary. Use when backend implements GET /safety/heat-index-metrics/summary */
export const fetchHeatIndexSummary = async (
  params?: SensorMetricSummaryParams,
): Promise<SensorMetricSummary> => {
  const res = await axios.get(`${BASE_URL}/safety/heat-index-metrics/summary`, {
    params,
  })
  const response = await res.data
  return response.data
}

/** Fumes summary. Use when backend implements GET /safety/fumes-metrics/summary */
export const fetchFumesSummary = async (
  params?: SensorMetricSummaryParams,
): Promise<SensorMetricSummary> => {
  const res = await axios.get(`${BASE_URL}/safety/fumes-metrics/summary`, {
    params,
  })
  const response = await res.data
  return response.data
}

/** Air quality summary. Use when backend implements GET /safety/air-quality-metrics/summary */
export const fetchAirQualitySummary = async (
  params?: SensorMetricSummaryParams,
): Promise<SensorMetricSummary> => {
  const res = await axios.get(
    `${BASE_URL}/safety/air-quality-metrics/summary`,
    { params },
  )
  const response = await res.data
  return response.data
}

// --- Mission air quality (existing backend: GET /mission/air-qualities/?project=) ---
export interface MissionAirQualityReading {
  id: number
  mission_id: number
  sub_viewpoint_id: number
  gas: number | null
  humidity: number | null
  pressure: number | null
  temperature: number | null
  pm25: number | null
  pm100: number | null
  taken_on: string | null
  project_id: string
}

/** List air quality readings by project. Backend: GET /mission/air-qualities/?project= */
export const fetchMissionAirQualityByProject = async (
  projectId: string,
): Promise<MissionAirQualityReading[]> => {
  const res = await axios.get(`${BASE_URL}/mission/air-qualities/`, {
    params: { project: projectId },
  })
  const response = await res.data
  return response.data ?? response
}

// --- Sensor readings for floor (Heat Index, Fumes, Air Quality maps) ---
export interface SensorReadingResponseItem {
  id: number
  viewpoint: number
  temperature: number | null
  humidity: number | null
  gas: number | null
  pm25: number | null
  pm100: number | null
  taken_on: string | null
}

export interface SensorReading {
  id: number
  mission_id: number
  point_id: number
  taken_on: string
  temperature: number
  humidity: number
  pressure: number
  gas: number
  pm25: number
  pm100: number
}

/** List sensor readings by project, floor, and optional date. Backend: GET /safety/sensor-readings */
export const fetchSensorReadingsForFloor = async (
  projectId: string,
  floorCode: string | undefined,
  date?: Date,
): Promise<SensorReadingResponseItem[]> => {
  const params: Record<string, string> = { project_id: projectId }
  if (floorCode) params.floor_code = floorCode
  if (date) {
    params.date = date.toISOString().slice(0, 10)
  }
  const res = await axios.get(`${BASE_URL}/safety/sensor-readings`, {
    params,
  })
  const data = res.data
  return Array.isArray(data) ? data : (data?.data ?? [])
}

export interface UpdateSensorReadingRequest {
  heat_index_f?: number
  temperature?: number
  humidity?: number
}

/** Update a sensor reading (superuser only). Backend: PATCH /safety/sensor-reading/:id */
export const updateSensorReading = async (
  readingId: number,
  payload: UpdateSensorReadingRequest,
): Promise<SensorReadingResponseItem> => {
  const res = await axios.patch(
    `${BASE_URL}/safety/sensor-reading/${readingId}`,
    payload,
  )
  const data = res.data
  return data?.data ?? data
}
